module.exports = __webpack_public_path__ + "static/media/mode10.71d7d238.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode10.gif
// module id = 1440
// module chunks = 110